import { ActivatedRoute, Params, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';

import { AccountService } from '../services/account.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css'],
})
export class ResetPasswordComponent implements OnInit {
  public token: string;
  public expiredToken = false;

  constructor(
    private route: ActivatedRoute,
    private accountService: AccountService,
    private router: Router,
    private toastrService: ToastrService
  ) {}

  ngOnInit(): void {
    // get params from route
    this.route.params.subscribe((params: Params) => {
      this.token = params['token'];
    });
  }

  /**
   * Sets new password
   * @param createPasswordForm
   */
  setPassword(createPasswordForm: FormGroup) {
    this.onSubmit(createPasswordForm.get('password').value);
  }

  /**
   * Submits new password form
   * @param newPassword
   */
  onSubmit(newPassword): void {
    this.accountService.resetPassword(this.token, newPassword).then(
      (data) => this.resetPwdSuccess(data),
      (err) => this.resetPwdFailure(err)
    );
  }

  /**
   * Resets password success
   * @param result
   */
  private resetPwdSuccess(result: any): void {
    this.toastrService.success(
      $localize`:@@authentication_resetPasswordFormFilled_toastSuccessMessage:Your password is well modified`
    );
    this.router.navigate(['/sign-in']);
  }

  /**
   * Resets password failure
   * @param error
   */
  private resetPwdFailure(error: any): void {
    this.toastrService.warning(
      $localize`:@@settings_editAccount_ErrorDescription:A problem is occured, please retry later`
    );
  }
}
